<template>
  <div
      :class="{
        'SELECTED': isSelected,
        'PRESELECTED': isPreselected,
        'TOUCHED': isTouched,
        'UNSELECTED': !isSelected
      }"
      class="PROCARD-HEADER"
      selenium="select-pro-check-button"
      @click="$emit('toggleSelection')">
    <div class="d-flex jc-between ai-center p-2">
      <div class="AVATAR-IMAGE">
        <pro-avatar :image="avatar" :size="size" selenium="pro-avatar-label"/>
        <img
            v-if="isTopPro"
            v-tooltip="{
              targetClasses: 'c-white',
              content: 'Verified top performance.',
            }"
            class="FIVE-STAR-BADGE"
            src="@/assets/TopPro.svg"
            height="32"
            width="32"
        >
        <img
            v-else-if="isFiveStar"
            v-tooltip="{
              targetClasses: 'c-white',
              content: 'Pros with a 5-star rating.',
            }"
            class="FIVE-STAR-BADGE"
            src="@/assets/FiveStarPro.svg"
            height="32"
            width="32"
            selenium="public-profile-five-stars-badge"
        >
      </div>
      <div v-if="isModal" class="CHECK">
        <vk-icon name="checkmark" size="15"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pro-card-header-new',
  props: {
    avatar: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 85,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isPreselected: {
      type: Boolean,
      default: false,
    },
    isTouched: {
      type: Boolean,
      default: false,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    isTopPro: {
      type: Boolean,
      default: false,
    },
    isFiveStar: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

  <style lang="scss" scoped>
    @import "~@homeservices/design-kit/tools";

    @mixin ProCard-selectButtonIconText($text) {
      @include absolute(auto, auto, 20px, 55px);
      @include text-medium();
      content: $text;
      font-weight: 400;
      color: $color-gray40;

      @include desktop {
        @include absolute(5px, 24px, auto, auto);
      }
    }

    @mixin ProCard-selectButtonIconTextModal($text) {
      @include ProCard-selectButtonIconText($text);
      @include absolute(auto, auto, 20px, 55px);
      @include desktop {
        @include absolute(65px, 15px, auto, auto);
      }
    }

    .PROCARD-HEADER {
      height: 100%;
      position: relative;

      @include desktop {
        width: 100%;
        height: 100%;
      }

      &:before {
        @include absolute(0, auto, auto, 0);
        @include rect(50%, 100%);
        content: '';
        background: $color-gray60;

        @include desktop {
          @include absolute(0, auto, auto, 0);
          @include rect(50%, 100%);
        }
      }

      &.PRO-INFO-MODAL-HEADER {
        height: 190px;

        @include desktop {
          height: 100px;
        }

        &:before {
          @include desktop {
            @include absolute(100px, auto, auto, 0);
          }
        }
      }

      &:hover {
        .CHECK {
          color: white;
          background-color: $color-depot;
        }
      }
    }

    .UNSELECTED {
      .CHECK {
          color: $color-gray60;
      }
    }

    .SELECTED:before {
      background-color: #fea972;
    }

    .SELECTED {
      .CHECK {
        color: $color-depot;
        background-color: white;
        border-color: $color-depot;
      }

      &:hover {
        .CHECK {
          color: white;
          background-color: $color-gray60;
          border-color: $color-depot;
        }
      }
    }

    .AVATAR-IMAGE {
      @include square(92px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      border-radius: 50%;
      z-index: 20;
    }

    .PRO-INFO-MODAL-HEADER {
      .CHECK {
        @include absolute(auto, auto, 15px, 10px);

        @include desktop {
          @include absolute(95px, 25px, auto, auto);
        }
      }
      .AVATAR-IMAGE {
        @include square(80px);
        @include desktop {
          @include square(210px);
        }
      }

      &.PRESELECTED {
        &:not(.TOUCHED):after {
          @include ProCard-selectButtonIconTextModal('Preselected');
        }
      }

      &.SELECTED {
        &:hover:after {
          @include ProCard-selectButtonIconTextModal('Deselect');
        }
      }

      &.UNSELECTED {
        &:hover:after {
          @include ProCard-selectButtonIconTextModal('Select');
        }
      }
    }

    .CHECK {
      @include absolute(10%, 10%, auto, auto);
      @include square(30px);
      border: 2px solid $color-gray40;
      border-radius: 50%;
      text-align: center;
      background-color: white;
      z-index: 20;
      padding: 4px 0;

      @include desktop {
        @include absolute(10%, 10%, auto, auto);
      }
    }
    .FIVE-STAR-BADGE {
      position: absolute;
      bottom: 12%;
      left: 55%;
    }
  </style>
